// react-rails mount entry for `react_component 'AiConfigureReviewHeader'`.
// The frontend/packs require.context resolves a mounted component by matching
// its name to a top-level path under frontend/features/, so the mount point
// must live here even though the implementation lives with the shared menu.
export { default } from '../AiConfigureMenu/AiConfigureReviewHeader';
